import { render } from "./MinusIcon.vue?vue&type=template&id=5acda076&scoped=true"
const script = {}

import "./MinusIcon.vue?vue&type=style&index=0&id=5acda076&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5acda076"]])

export default __exports__